import script from "./DiffusionZone.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiffusionZone.vue?vue&type=script&setup=true&lang=ts"

import "./DiffusionZone.vue?vue&type=style&index=0&id=5b28fe59&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b28fe59"]])

export default __exports__